module.exports = __webpack_public_path__ + "static/img/logo_51.d4e7891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_51.png
// module id = tcdP
// module chunks = 1